import { render } from "./appFoot.vue?vue&type=template&id=38fe07ce&scoped=true"
import script from "./appFoot.vue?vue&type=script&lang=js"
export * from "./appFoot.vue?vue&type=script&lang=js"

import "./appFoot.vue?vue&type=style&index=0&id=38fe07ce&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38fe07ce"]])

export default __exports__